import { getCourse, getUserInfo } from "../redux/actions";
import { resetCourseThrottle } from "../redux/actions/courseActions";
import { resetUserInfoThrottle } from "../redux/actions/userActions";
import { clearCalendarCache } from "./calendarCache";
import { markHomeDataStale } from "./homeDataFreshness";

// Reload everything that shows the member's FREE status after the trial changes.
// The profile and course fetches are both throttled: without the resets, a cancel
// made within their window re-dispatched them and nothing on screen changed.
export const refreshAfterFreeTrialChange = async (dispatch) => {
  resetUserInfoThrottle();
  resetCourseThrottle();
  clearCalendarCache();
  markHomeDataStale();
  await Promise.allSettled([dispatch(getUserInfo()), dispatch(getCourse())]);
};
